import React from 'react';
import GlobalBannerNotification from '@rotaryintl/harris-global-banner-notification';
import WBRString from '@component/WbrString';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const GlobalBannerNotificationsComponent = (props) => {
  let notifications = props.fields.children.map((notification, index) => {
    let richText = (
      <>
        <WBRString>{notification?.text}</WBRString>
      </>
    );
    if (notification?.isActive) {
      return (
        <GlobalBannerNotification
          key={index}
          storageId={notification?.storageId}
          title={notification?.title}
          isDismissible={notification?.isDismissible}
          text={richText}
          variant={notification?.variant}
        />
      );
    }
  });
  return <>{notifications}</>;
};
export default withSitecoreContext()(GlobalBannerNotificationsComponent);
